import { createApi } from '@reduxjs/toolkit/query/react'

import { getFirebase } from '~/firebase'
import { apiPrivate } from '~/redux/utils/hom-api'
import { Timestamp } from '~/storage/types'

interface Response {
  success: boolean
}

interface Dragon {
  activityTickRate: number
  affectionCapacity: number
  created: Timestamp
  evolution: string
  evolutionOrder: number
  gemProduction: number
  id: string
  tickRate: number
  updated: Timestamp
  userId: string
}

export interface DragonData {
  data: Dragon
  success: boolean
}

export const dragonApi = createApi({
  reducerPath: 'dragonApi',
  tagTypes: ['dragon'],
  baseQuery: apiPrivate,
  endpoints: (build) => ({
    createDragon: build.mutation<Response, void>({
      queryFn: async () => {
        const { httpsCallable, functions } = await getFirebase()
        const status = await httpsCallable<void, boolean>(functions, 'createDragon')()
        return {
          data: status.data,
        }
      },
      invalidatesTags: ['dragon'],
    }),
    getDragon: build.query<DragonData, void>({
      queryFn: async () => {
        const { httpsCallable, functions } = await getFirebase()
        const response = await httpsCallable<void, DragonData>(functions, 'getDragon')()
        return {
          data: response.data,
        }
      },
      providesTags: ['dragon'],
    }),
    evolveDragon: build.mutation<Response, void>({
      queryFn: async () => {
        const { httpsCallable, functions } = await getFirebase()
        const status = await httpsCallable<void, boolean>(functions, 'evolveDragon')()
        return {
          data: status.data,
        }
      },
      invalidatesTags: ['dragon'],
    }),
  }),
})

export const { useCreateDragonMutation, useEvolveDragonMutation, useGetDragonQuery } = dragonApi
